export default {
  "content": "<title>Ellipsis Vertical</title><circle cx=\"256\" cy=\"256\" r=\"48\"/><circle cx=\"256\" cy=\"416\" r=\"48\"/><circle cx=\"256\" cy=\"96\" r=\"48\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};